import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import { Citation } from './types';
import { ActionButtons } from './ui/ActionButtons';
import { CitationButtons } from './ui/CitationButtons';
import { CitationTable } from './ui/CitationTable';
import { downloadCSV } from './utils/downloadCSV';

type MessageActionsProps = {
  messageContent: string | ReactNode;
  citations?: Citation[];
};

const DialogHeader = () => (
  <div className="flex justify-content-between align-items-center w-full">
    <span>Citation Details</span>
  </div>
);

export const MessageActions = ({
  messageContent,
  citations,
}: MessageActionsProps) => {
  const [selectedCitation, setSelectedCitation] = useState<Citation | null>(
    null,
  );
  const [dialogVisible, setDialogVisible] = useState(false);

  const showCitation = useCallback((citation: Citation) => {
    setSelectedCitation(citation);
    setDialogVisible(true);
  }, []);

  const handleHideDialog = useCallback(() => {
    setDialogVisible(false);
  }, []);

  const handleDownload = useCallback(() => {
    if (selectedCitation) {
      downloadCSV(selectedCitation.data);
    }
  }, [selectedCitation]);

  const showDownloadButton = useMemo(() => {
    if (!selectedCitation) return false;
    try {
      const data = JSON.parse(selectedCitation.data);
      return Array.isArray(data) && data.length > 0;
    } catch {
      return false;
    }
  }, [selectedCitation]);

  return (
    <>
      <div className="message-footer">
        {citations && citations.length > 0 && (
          <CitationButtons
            citations={citations}
            onCitationClick={showCitation}
          />
        )}
        <ActionButtons messageContent={String(messageContent)} />
      </div>

      <Dialog
        header={<DialogHeader />}
        visible={dialogVisible}
        onHide={handleHideDialog}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      >
        {selectedCitation && (
          <div className="citation-content">
            <h3>Explanation</h3>
            <p className="mb-4">{selectedCitation.explanation}</p>
            <div className="flex justify-content-between align-items-center mb-2">
              <h3 className="m-0">Data</h3>
              {showDownloadButton && (
                <Button
                  icon="pi pi-download"
                  onClick={handleDownload}
                  className="p-button-text p-button-sm"
                  tooltip="Download CSV"
                  tooltipOptions={{ position: 'left' }}
                />
              )}
            </div>
            <CitationTable data={selectedCitation.data} />
          </div>
        )}
      </Dialog>
    </>
  );
};
